import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW6001Model } from '../kymw6001.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 特集候補商品一覧情報更新サービス
 * @export UpdateCheckStatusService
 * @class UpdateCheckStatusService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateCheckStatusService extends PlessJsonResponderSub<any> {
  model: KYMW6001Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateCheckStatusService
   */
  private getBody(): PlessRequest {
    type addItem = {
      condition: {
        OrderCode: string,
        PCode: string,
        CoopCode?: string,
        ImageId?: string,
        ShowSeq?: string,
        ImageCheckFlag?: string,
        TextCaption?: string,
        SkewerSelect?: string,
      }
    }

    const updateParam = [];
    this.model.imageListInfo.forEach(item => {
      if (item.editFlg) {
        let addItemList = [];
        let addItem: addItem;

        let enabledCoopList = this.model.pcodeInfoList.find(_ => 
          item.pCode == _.pCode
        ).coopInfoList.map(coopInfo => coopInfo.coopCode);
        enabledCoopList.forEach(coopCode => {
          addItem = {
            condition: {
              OrderCode: this.model.orderCode,
              PCode: item.pCode,
              CoopCode: coopCode,
            }
          }
          addItemList.push(addItem);
        });

        for (const imageItem of item.orderImageListInfo) {
          // 商品の画像指示が空行のみの場合は受注コード・Pコード・生協コード、串刺状況のみ
          if (item.orderImageListInfo.length == 1 && imageItem.imageDetailListInfo.length == 0) {
            enabledCoopList.forEach(coop => {
              const emptyCoop = addItemList.find(item => item.condition.CoopCode == coop);
              let fixedAddItemList = {
                condition: {
                  ...emptyCoop.condition,
                  SkewerSelect: imageItem.skewerSelect ? '1' : '0',
                }
              }
              updateParam.push(fixedAddItemList);
            });
            break
          } else if (item.orderImageListInfo.length > 1 && imageItem.imageDetailListInfo.length == 0) {
            // 空行と画像指示設定行がある場合、空行は受注コード・Pコード・生協コード、串刺状況のみ
            enabledCoopList.forEach(coop => {
              if (imageItem[`coopFlg${coop}`] === '1') {
                const emptyCoop = addItemList.find(item => item.condition.CoopCode == coop);
                let fixedAddItemList = {
                  condition: {
                    ...emptyCoop.condition,
                    SkewerSelect: imageItem.skewerSelect ? '1' : '0',
                  }
                }
                updateParam.push(fixedAddItemList);
              }
            });
          }
          imageItem.imageDetailListInfo.forEach(imageDetail => {
            enabledCoopList.forEach(coop => {
              if (imageItem[`coopFlg${coop}`] === '1') {
                addItem = addItemList.find(item => item.condition.CoopCode == coop);
                addItem = {
                  condition: {
                    ...addItem.condition,
                    ImageId: imageDetail.imageFileId,
                    ShowSeq: imageDetail.showSeq,
                    ImageCheckFlag: item.imageChk ? "1" : "0",
                    TextCaption: imageDetail.textCaption,
                    SkewerSelect: imageItem.skewerSelect ? '1' : '0',
                  }
                }
                updateParam.push(addItem);
              }
            });
          });
        };
      }
    });

    const updateVal = {
      UseImageList: {
        combination: [
          ...updateParam
        ]
      }
    }
    return new PlessRequest({
      update: { UseImageList: updateVal.UseImageList }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdateCheckStatusService
   */
  execute(model: KYMW6001Model, f?: () => void): void {
    this.model = model;
    this.calbak = f;
    this.send('updateCheckStatus', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateCheckStatusService
   */
  success(data: any) {
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
